module.exports = __webpack_public_path__ + "static/media/NAVARRO.741c9ee7.png";